const actions = {
  SET_STATE: 'user/SET_STATE',
  // SET_STATE0: 'user/SET_STATE0',
  LOGIN: 'user/LOGIN',
  LOGIN_BY_KEY: 'user/LOGIN_BY_KEY',
  OAUTHLOGIN: 'user/OAUTHLOGIN',
  LOGIN_BY_TOKEN: 'user/LOGIN_BY_TOKEN',
  REGISTER: 'user/REGISTER',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  LOGOUT: 'user/LOGOUT',
  LOGIN_BY_OTP: 'user/LOGIN_BY_OTP', // /auth/loginwithemail
  UMK_LOGIN: 'user/UMK_LOGIN',
  UMK_REGISTER: 'user/UMK_REGISTER',
  UMK_CHANGEPW: 'user/UMK_CHANGEPW',
}

export default actions
